import { Snackbar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NotificationStyled = styled(Snackbar)(({ theme }) => ({
  '& .MuiSnackbarContent-root': {
    width: '400px',
    flexWrap: 'nowrap',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    boxShadow: `
      0px 1px 18px 0px #0000001F,
      0px 6px 10px 0px #00000024,
      0px 3px 5px -1px #00000033
    `,
    padding: '16px',
    minHeight: '60px',
    fontSize: '14px',
  },
  '& .MuiSnackbarContent-message': {
    padding: 0,
    flex: 1,
  },
  '& .MuiSnackbarContent-action': {
    padding: 0,
    marginRight: 0,
    marginTop: '2px',
    alignSelf: 'flex-start',
  },
}));
